import { Contact } from 'src/app/models';
import {
  Component,
  OnInit,
  ComponentFactoryResolver,
  Inject,
  forwardRef,
  Input,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { ContactListDataEntity } from '../../../../../models/data-entities/contact-list-data-entity';
import { NgForm, UntypedFormBuilder } from '@angular/forms';
import { ClientService, WorkflowContextService } from '../../../../../services';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { ContactEmailAddress, ContactAddress } from '../../../../../models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-contact-list-data-entity-view',
    templateUrl: './contact-list-data-entity-view.component.html',
    styleUrls: ['./contact-list-data-entity-view.component.css'],
    standalone: false
})
export class ContactListDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  @Input() entity: ContactListDataEntity;
  templateForPermitForm: boolean = false;         // Added by Vipul on 17/12/2025
  @ViewChild('content') content!: TemplateRef<any>;         // Added by Vipul on 18/12/2025
  dialogRef!: MatDialogRef<any>;         // Added by Vipul on 18/12/2025
  // constructor(
  //   componentFactoryResolver: ComponentFactoryResolver,
  //   private _fb: FormBuilder
  //   )
  constructor(
    //  _dataSvc: DataService,
    public layoutService: LayoutService,
    componentFactoryResolver: ComponentFactoryResolver,
    @Inject(forwardRef(() => ClientService)) public _clientSvc: ClientService,
    @Inject(forwardRef(() => WorkflowContextService))
    private _context: WorkflowContextService,
    @Inject(forwardRef(() => ActivatedRoute)) private route: ActivatedRoute,
    private _fb: UntypedFormBuilder,
    private modalService: NgbModal,
    private dialog: MatDialog,    //Added by vipul on 18/12/2025
  ) {
    super(layoutService, componentFactoryResolver, _context);
    // Started by Vipul on 17/12/2025
    layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
    // End by Vipul on 17/12/2025
  }

  onFormSubmit(form: NgForm) {}

  open(content) {

    if (this.templateForPermitForm) {
      this.dialogRef = this.dialog.open(this.content, {
        width: '600px'
      });
    } else {
      this.modalService.open(content, { ariaLabelledBy: 'modal-contact' });
    }
  }

  closeDialog(): void {
    this.dialogRef?.close();
  }

  ngOnInit() {
    //get the contact //this is messy, but it's because it's the way shawn implemnted it in contactdetalview.
    //this should all be moved down to the getContact service layer.
    this.route.params.subscribe(params => {
      if ((this.entity.selectedContactId || '') != '') {
        const z = this._clientSvc.getContact(this.entity.selectedContactId);

        z.pipe(
          map(contact => {
            this.entity.selectedContact = contact;
            if (this.entity.selectedContact.emailAddress == null) {
              this.entity.selectedContact.emailAddress = new ContactEmailAddress();
            }
            if (this.entity.selectedContact.address == null) {
              this.entity.selectedContact.address = new ContactAddress();
            }
            return this.entity.selectedContact;
          })
        ).subscribe(res => {
          this.entity.selectedContact = res;
        });
      } else {
        this.entity.selectedContact = this._clientSvc.createContact();
      }
    });
  }

  getOfficeHours(contact: Contact) {
    return contact.officeHours.replace(new RegExp('\n', 'g'), '<br />');
  }

  // Started by Vipul on 19/12/2025
  get addressLines(): string[] {
    const address = this.entity?.selectedContact?.address;
    if (!address) return [];

    return [
      address.address1,
      address.address2,
      address.city && address.state
        ? `${address.city}, ${address.state} ${address.zip}`
        : null
    ].filter(Boolean) as string[];
  }

  // Started by Vipul on 19/12/2025
}
